(function () {
  angular.module("akitabox.asset.detail").run(states);

  /* @ngInject */
  function states(Router) {
    Router.configureStates([
      {
        state: "app.building.asset.detail",
        config: {
          url: "",
          templateUrl: "app/mobile/modules/asset/detail/detail.html",
          controller: "AssetDetailController",
          controllerAs: "vm",
          data: {
            pageTitle: "Asset",
          },
        },
      },
    ]);
  }
})();
